(function () {
    'use strict';

    angular
        .module('ib-ancillaries-activities-globick-module')
        .controller('AncillariesActivitiesGlobickController', AncillariesActivitiesGlobickController);

    AncillariesActivitiesGlobickController.$inject = ['$window', '$rootScope', '$timeout', 'CommonsSessionStorageService'];
    function AncillariesActivitiesGlobickController ($window, $rootScope, $timeout, CommonsSessionStorageService) {
        const vm = this;
        vm.removeActivitiesGlobick = removeActivitiesGlobick;


        /**
         * Remove activities globick from basket.
         */
        function removeActivitiesGlobick (index) {
            $timeout(() => {
                const activityGlobick = CommonsSessionStorageService.get('removeGlobickActivities');
                const deleteInfo = [
                    {
                        type: 'GLOBICK',
                        items: [
                            {
                                product: 'EXP',
                                bookingReferences: [String([activityGlobick[0].items[0].bookingReferences[0][index]])]
                            }
                        ]
                    }
                ];
                vm.basketFunctions.isLoading();

                vm.basketFunctions.deleteAncillariesService.deleteAncillarie(deleteInfo).then(() => {
                    removeParameters(index);
                    deleteActivitiesGlobickSucess();
                    $rootScope.$broadcast('basketUpdateCommonHeader');
                }, (error) => {
                    vm.basketFunctions.isNotLoading();
                    vm.basketFunctions.modalService.setErrorMessage(error.message);
                    vm.basketFunctions.modalService.setErrorCode(error.internalErrorCode);
                    vm.basketFunctions.modalService.isError(error);
                    vm.basketFunctions.collapseHeader.closeCollapse();
                });
            });
        }

        function removeParameters (index) {
            vm.model.info.description.splice(index, 1);
            vm.model.info.totalFormatted.splice(index, 1);
            const removeGlobickActivities = CommonsSessionStorageService.get('removeGlobickActivities');
            const bookingReferencesActivities = CommonsSessionStorageService.get('bookingReferencesActivities');
            const activitiesData = CommonsSessionStorageService.get('activitiesData');
            let removeGlobickActivitiesUpdated = [];

            if (removeGlobickActivities[0].items[0].bookingReferences[0].length >= 1
                && Array.isArray(removeGlobickActivities[0].items[0].bookingReferences[0])) {
                removeGlobickActivities[0].items[0].bookingReferences[0].splice(index, 1);
                removeGlobickActivitiesUpdated = [
                    {
                        type: 'GLOBICK',
                        items: [
                            {
                                product: 'EXP',
                                bookingReferences: [removeGlobickActivities[0].items[0].bookingReferences[0]]
                            }
                        ]
                    }
                ];
            } else {
                removeGlobickActivitiesUpdated = null;
            }

            CommonsSessionStorageService.set('removeGlobickActivities', removeGlobickActivitiesUpdated);
            CommonsSessionStorageService.set('bookingReferencesActivities', bookingReferencesActivities.splice(index, 1));
            if (activitiesData[0].length <= 1) {
                CommonsSessionStorageService.set('activitiesData', ['', '', '', '', '']);
            } else {
                activitiesData[0].splice(index, 1);
                activitiesData[1].splice(index, 1);
                activitiesData[2].splice(index, 1);
                activitiesData[3].splice(index, 1);
                activitiesData[4].splice(index, 1);
                CommonsSessionStorageService.set('activitiesData', [activitiesData[0], activitiesData[1], activitiesData[2], activitiesData[3], activitiesData[4]]);
            }
            const activitiesDataUpdated = CommonsSessionStorageService.get('activitiesData');
            const dateGoingTrip = activitiesDataUpdated[0];
            const description = activitiesDataUpdated[1];
            const price = activitiesDataUpdated[2];
            for (let i = 0; i < dateGoingTrip.length; i++) {
                const date = new Date(dateGoingTrip[i]);
                dateGoingTrip[i] = String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear();
            }
            $rootScope.$broadcast('updateHeaderGlobickActivities', {
                dateGoingTrip,
                description,
                price
            });
        }

        function deleteActivitiesGlobickSucess (actualPage) {
            const headerModel = CommonsSessionStorageService.get('headerModel');
            if (!headerModel.shoppingBasket.globickActivities.info) {
                $rootScope.$broadcast('deleteGlobickActivities', vm.model);
                vm.model.info = null;
                vm.model.hasActivitiesGlobick = false;
                headerModel.shoppingBasket.globickActivities.hasActivitiesGlobick = false;
                CommonsSessionStorageService.remove('activitiesData');
                CommonsSessionStorageService.remove('bookingReferencesActivities');
                CommonsSessionStorageService.remove('removeGlobickActivities');
            }


            vm.basketFunctions.isNotLoading();
        }
    }
})();